import * as React from 'react';

export const VariablesContext = React.createContext<{ [slug: string]: string }>(
  {}
);
